import { Box, makeStyles } from '@material-ui/core';
import { useParams } from '@reach/router';
import React, { useEffect, useState } from 'react';

import TableGrid, { CellRenderer, MainColumns } from '../../../../components/TableGrid';
import TablePagination from '../../../../components/TableGrid/Pagination';
import { useTableGridApiState } from '../../../../components/TableGrid/TableGridApiContext/TableGridApiContext';
import { useAppGoogleReCaptcha } from '../../../../hooks/useAppGoogleReCaptcha';
import { getDatasource } from '../../Companies/SearchList/SearchList';
import {
  useCompaniesDispatch,
  useCompaniesState,
} from '../../shared/CompanyContext/CompanyContext';
import { CompanyContextActionTypes } from '../../shared/CompanyContext/CompanyContext.types';
import { useErrorsDispatch } from '../../shared/ErrorContext/ErrorContext';
import { useFilterState } from '../../shared/FinancialDataContext/FinancialDataContext';
import NavigationHeader from './NavigationHeader';

const SearchPanel: React.FC = () => {
  const classes = useStyles();
  const { companies, pagination } = useCompaniesState();
  const { tableGridApi } = useTableGridApiState();
  const { requestFiltersData, historySearch, sortModel } = useFilterState();
  const dispatchCompanies = useCompaniesDispatch();
  const dispatchErrors = useErrorsDispatch();
  const [companiesVisibleCount, setCompaniesVisibleCount] = useState<number>(0);
  const { executeRecaptcha } = useAppGoogleReCaptcha();
  const { benchmarkId } = useParams();

  useEffect(() => {
    setCompaniesVisibleCount(companies.length);
  }, [companies]);

  return (
    <Box className={classes.searchPanelBox}>
      {companiesVisibleCount > 0 ? <NavigationHeader /> : null}
      <TableGrid
        translationKey="companies:companyInfo"
        columns={columnDefs(benchmarkId)}
        getDatasource={getDatasource(executeRecaptcha)}
        isShowSideBar={false}
        suppressTableContextProvider={true}
        initialSortModel={sortModel}
        originalProps={{
          context: {
            requestFiltersData,
            pagination,
            historySearch,
            companies,
            dispatchCompanies,
            dispatchErrors,
          },
          headerHeight: 0,
          rowModelType: 'serverSide',
          pagination: true,
          paginationPageSize: pagination.size,
          cacheBlockSize: pagination.size,
          maxBlocksInCache: 1,
          suppressPaginationPanel: true,
          rowSelection: 'single',
          rowMultiSelectWithClick: false,
          defaultColDef: defaultColumnProp,
        }}
      >
        {companiesVisibleCount > 0 ? (
          <TablePagination
            gridApi={tableGridApi}
            pagination={pagination}
            onChange={(value: number) => {
              dispatchCompanies({
                type: CompanyContextActionTypes.SetPagination,
                payload: { ...pagination, page: value },
              });
            }}
          />
        ) : null}
      </TableGrid>
    </Box>
  );
};

const defaultColumnProp = {
  resizable: true,
  flex: 1,
  minWidth: 100,
  menuTabs: [],
  sortable: false,
};

const columnDefs = (benchmarkId?: string): MainColumns[] => [
  {
    headerName: '',
    field: 'companyInfo.name',
    minWidth: 300,
    cellClass: 'companyTitle',
    cellRenderer: CellRenderer.Link,
    cellRendererParams: {
      benchmarkId: benchmarkId,
    },
  },
];

const useStyles = makeStyles((theme) => ({
  searchPanelBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '340px',
    paddingLeft: theme.spacing(4),
    '& .ag-row-selected': {
      backgroundColor: theme.palette.primary.main,
      '& .companyTitle': {
        color: theme.palette.background.paper,
      },
    },
    '& .ag-root-wrapper-body': {
      height: '100%',
    },
    '& .ag-theme-alpine .ag-header': {
      borderBottom: 'none',
    },
    marginRight: theme.spacing(8),
  },
}));
export default SearchPanel;
